/* global bocAmchart */
/* exported quarterFunction, postProcessValet, bocChart, handleRender */

/**
 * Returns the proper quarter label  based on the date
 *
 * @param {string} label    label to be entered
 * @param {date} date       the date object
 * @returns {string}         the proper string including the quarter
 */
function quarterFunction(label, date) {
    return bocAmchart.quarterFunction(label, date);
}

/**
 * Produces and returns an array of data based on the valet data
 *
 * @param {object} data Object containing the valet data sets
 * @returns {array} output array of data
 */
function postProcessValet(data) {
    return bocAmchart.postProcessValet(data);
}

/**
 * @typedef {{bocSettings: {series, ga, addExport, lookup}, listeners, export}} AMConfig
 */

/**
 * Apply BOC settings to a chart.
 * @param {AMConfig} chart The chart options
 * @returns {AMConfig} Modified chart options
 */
function bocChart(chart) {
    return bocAmchart.applyBocSettings(chart);
}

/**
 * Apply BOC settings to a chart.
 * @param {object} event render AMCharts event
 * @returns {void}
 */
function handleRender(event) {
    bocAmchart.handleRender(event);
}